import axios from "axios";
const apiUrl = process.env.REACT_APP_API_URL;
const api = axios.create({
    baseURL: `${apiUrl}/api`,
    withCredentials: true
});

// Global flag used by polling to mark requests
window.__sessionPollingActive = false;

api.interceptors.response.use(
    (response) => {
        const data = response.data;
        if (data && typeof data === 'object' && 'Succeeded' in data && 'Message' in data && 'Data' in data) {
            if (data.Succeeded) {
                if (data.Data === null) {
                    response.data = { Succeeded: true, Message: data.Message };
                } else if (typeof data.Data === 'object' && !Array.isArray(data.Data)) {
                    response.data = { ...data.Data, Succeeded: true, Message: data.Message };
                } else {
                    response.data = data.Data;
                    if (Array.isArray(response.data)) {
                        response.data.Succeeded = true;
                        response.data.Message = data.Message;
                    }
                }
            } else {
                response.data = { Succeeded: false, Message: data.Message, ...data.Data };
            }
        }
        return response;
    },
    (error) => {
        if (error.response) {
            if (error.response.status === 401) {
                const path = window.location.pathname;
                const isAuthPage = path.includes('/login') || path.includes('/auth/');
                
                const publicPaths = ['/home', '/about-us', '/our-service', '/appointment', '/article', '/pricing', '/terms-condition', '/blog-post', '/accept-invitation'];
                const isPublicPage = path === '/' || publicPaths.some(p => path.startsWith(p));
                
                // If already on auth page, do nothing
                if (isAuthPage) {
                    return Promise.reject(error);
                }

                if (isPublicPage) {
                    window.dispatchEvent(new CustomEvent('silent-logout'));
                    return Promise.reject(error);
                }

                // If already logging out, just freeze
                if (window.isLoggingOut) {
                    return new Promise(() => {});
                }

                // Mark as logging out to prevent duplicate toasts
                window.isLoggingOut = true;

                // Dispatch custom event — triggers SessionExpiredOverlay component
                window.dispatchEvent(new CustomEvent('session-expired'));

                return new Promise(() => {}); // Freeze to keep user on page while overlay shows
            } else if (error.response.status === 403) {
                // Handle forbidden
                console.error("Access forbidden");
            } else if (error.response.status === 500) {
                // Global error middleware returns 500
                console.error("Internal Server Error:", error.response.data);
            }
        }
        return Promise.reject(error);
    }
);

export default api;
